import { CircularProgress, Container, Typography } from "@mui/material";

export const Loading = () => {
  return (
    <Container>
      <Typography variant="h6" align="center">Authentication in progress</Typography>
      <CircularProgress />
    </Container>
  );
};
